import React, { forwardRef, useEffect, useRef, useState } from 'react';

import openEye from '../../../../assets/images/icons/eye-open.svg';
import closedEye from '../../../../assets/images/icons/eye-closed.svg';
import './InputItem.scss';

const InputItem = forwardRef(
  (
    { type = 'text', label = '', onChange, value = '', onKeyDown, className = '', isText = false, icon = null },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const textareaRef = useRef();

    useEffect(() => {
      if (isText && textareaRef.current) {
        textareaRef.current.style.height = 'auto';
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 2}px`;
      }
    }, [value, isText]);

    const handleEyeChange = () => {
      setShowPassword((state) => !state);
    };

    return (
      <div className="input">
        {isText ? (
          <textarea
            ref={(el) => {
              textareaRef.current = el;
              if (ref) {
                if (typeof ref === 'function') {
                  ref(el);
                } else {
                  ref.current = el;
                }
              }
            }}
            onChange={onChange}
            value={value}
            onKeyDown={onKeyDown}
            className={className}
            rows={label === 'Message *' ? 10 : 3}
            onInput={(e) => {
              e.target.style.height = 'auto';
              e.target.style.height = `${e.target.scrollHeight + 2}px`;
            }}
          />
        ) : (
          <input
            ref={ref}
            type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
            onChange={onChange}
            value={value}
            onKeyDown={onKeyDown}
            className={`${className} ${type}`}
          />
        )}
        <span className="input__label">
          {icon && <img src={icon} />}
          {label}
        </span>

        {type === 'password' && (
          <div className="eye-icon">
            <img src={showPassword ? openEye : closedEye} onClick={handleEyeChange} />
          </div>
        )}
      </div>
    );
  },
);

export default InputItem;
